export default __webpack_public_path__ + "static/media/start.131c12a8.svg";